/**
 * @name ChangePassword
 * @description Componente para cambiar la contraseña en configuración de perfil
 * @author Ricardo Guerra
 */

import React, { PureComponent } from 'react';

import { PasswordForm } from '@components';
import { AuthService, PasswordService, ResponseHandlerService } from '@services';

class ChangePassword extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  configPassword = (values, setSubmitting, resetForm, resetPasswordCheck) => {
    PasswordService.postPass({
      ContraseñaAnterior: values.oldPassword,
      ContraseñaNueva: values.newPassword,
      ConfirmarContraseña: values.confirmPassword
    }).then((response) => {
      setSubmitting(false);
      resetForm();
      resetPasswordCheck();
      let employee = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;
      AuthService.login({
        userName: employee.Usuario,
        password: values.newPassword,
        keepSession: false,
        useRefreshTokens: true
      });
      ResponseHandlerService.success(response);
    }).catch((error) => {
      setSubmitting(false);
      ResponseHandlerService.error(error);
    });
  }

  render() {
    return (
      <PasswordForm
        changePassword={true}
        retrievePassword={false}
        onConfigPassword={this.configPassword}
      />
    );
  }
}

export default ChangePassword;